module.exports = __webpack_public_path__ + "static/media/dot-logo.233e07c9.svg";